<div class="orders">
  <app-order-filters
    [isOpen]="isFilterOpen()"
    (closePanel)="toggleFilterPanel(false)"
    (filtersApplied)="handleFiltersApplied()"
    (sortApplied)="handleSortApplied($event)"
  />
  <h2 class="orders__title">{{ 'orders.pageHeader' | translate }}</h2>
  @let noMatchingOrdersState = orders().length === 0 && isAnyFilterApplied();
  @if (orders().length > 0 || ordersLoading() || noMatchingOrdersState) {
    <div class="orders__wrapper">
      <div class="table-container">
        <div class="table-heading">
          <app-inventory-table-search
            [placeholder]="'orders.table.placeholders.search' | translate"
          />
          <div class="orders__buttons">
            <button class="btn-white" (click)="toggleFilterPanel(true)">
              <span class="icon-wrapper">
                <app-icon class="icon" [icon]="iconName.FILTER" />
              </span>
              <span class="btn-text">
                {{ 'orders.table.buttons.filter' | translate }}
              </span>
            </button>
            <button
              mat-button
              color="primary"
              class="orders__create-order-btn add-button"
              routerLink="../create"
            >
              {{ 'orders.table.buttons.createOrder' | translate }}
            </button>
          </div>
        </div>

        <div class="filter-chips-container">
          <app-filter-chips />
        </div>

        <div class="table-wrapper">
          <table
            mat-table
            [dataSource]="ordersLoading() ? skeletonRows() : orders()"
            class="full-width-table"
          >
            @for (column of ordersTableColumnsConfig(); track column.key) {
              <ng-container [matColumnDef]="column.key">
                <th [class]="column.headerClass" mat-header-cell *matHeaderCellDef>
                  <div class="header-cell__wrapper">
                    <span>{{ column.label | translate }}</span>
                    @if (column.sortable) {
                      <app-icon class="icon" [icon]="iconName.SORTABLE_ARROW" />
                    }
                  </div>
                </th>
                <td [class]="column.cellClass" mat-cell *matCellDef="let order">
                  @if (ordersLoading()) {
                    @if (column.key === orderColumnKey.Actions) {
                      <div class="skeleton skeleton--icon"></div>
                    } @else {
                      <div class="skeleton skeleton--text"></div>
                    }
                  } @else {
                    @if (column.key === orderColumnKey.Id) {
                      <span class="orders__id">{{ order.id }}</span>
                    } @else if (column.isFullName) {
                      <div>{{ order.customerName }}</div>
                    } @else if (column.key === orderColumnKey.OrderStatus) {
                      <div class="status-container">
                        <span class="status" [ngClass]="order.orderStatus.toLowerCase()">
                          {{ formatOrderStatus(order.orderStatus) }}
                        </span>
                      </div>
                    } @else if (column.key === orderColumnKey.Actions) {
                      <button
                        class="cell"
                        mat-icon-button
                        [matMenuTriggerFor]="actionsMenu"
                        #menuTrigger="matMenuTrigger"
                      >
                        <mat-icon [class.menu-open]="menuTrigger.menuOpen">more_vert</mat-icon>
                      </button>
                      <mat-menu #actionsMenu="matMenu" class="actions-menu">
                        <button mat-menu-item (click)="openViewOrder(order)">
                          <app-icon class="icon-order" [icon]="iconName.VIEW_ORDER" />
                          {{ 'orders.table.actions.viewOrder' | translate }}
                        </button>
                        <button mat-menu-item (click)="openEditOrderStatus(order)">
                          <app-icon class="icon-order" [icon]="iconName.EDIT_STATUS" />
                          {{ 'orders.table.actions.editOrderStatus' | translate }}
                        </button>
                        <button mat-menu-item>
                          <app-icon class="icon-order" [icon]="iconName.PENCIL" />
                          {{ 'orders.table.actions.editOrderData' | translate }}
                        </button>
                        <button mat-menu-item (click)="printOrder(order.id)">
                          <app-icon class="icon-order" [icon]="iconName.PRINT_ORDER" />
                          {{ 'orders.table.actions.printOrder' | translate }}
                        </button>
                      </mat-menu>
                    } @else if (column.key === orderColumnKey.CreationDate) {
                      <span>{{ order.dateCreated | date: 'yyyy-MM-dd HH:mm:ss' }}</span>
                    } @else {
                      {{ order[column.key] }}
                    }
                  }
                </td>
              </ng-container>
            }
            <tr mat-header-row *matHeaderRowDef="ordersTableColumnKeys"></tr>
            <tr mat-row *matRowDef="let row; columns: ordersTableColumnKeys"></tr>
          </table>

          @if (noMatchingOrdersState && !ordersLoading()) {
            <div class="empty-filtered-table-message">
              {{ 'orders.table.emptyTable.noMatchingOrders' | translate }}
            </div>
          }
        </div>
      </div>

      <div class="orders__footer footer">
        @if (showPagination()) {
          <app-table-pagination
            [pagination]="ordersPagination()"
            (pageChange)="handlePageChange($event)"
            (pageSizeChange)="handlePageSizeChange($event)"
          />
        }
      </div>
    </div>
  } @else {
    <div class="empty-orders">
      <h2 class="empty-orders__title">{{ 'orders.table.emptyTable.noItemsTitle' | translate }}</h2>
      <span class="empty-orders__description">
        {{ 'orders.table.emptyTable.noItemsDescription' | translate }}
      </span>
      <button mat-button color="primary" class="orders__create-order-btn" routerLink="../create">
        {{ 'orders.table.buttons.createOrder' | translate }}
      </button>
    </div>
  }
</div>
